const Button = ({
  title,
  type = "button",
  style,
  isLoading,
  disabled,
  onHandler,
  props,
}) => {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled || isLoading}
      className={style}
      onClick={onHandler}
    >
      {isLoading && (
        <span role="status" aria-label="loading" className="btn_spinner"></span>
      )}
      {isLoading ? "Processing..." : title}
    </button>
  );
};

export default Button;
